import { render, staticRenderFns } from "./OverflowTank.vue?vue&type=template&id=9bdaa88a&"
import script from "./OverflowTank.vue?vue&type=script&lang=js&"
export * from "./OverflowTank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports